import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { AmlGlobalPage } from "./legal.aml-global";

export const Route = createFileRoute("/vi/legal/aml-global")({
  head: () => ({
    meta: [{ title: "AML & Tội phạm tài chính (Toàn cầu) — Banana Cards" }],
    links: alternateLinkList("/legal/aml-global", "vi"),
  }),
  component: AmlGlobalPage,
});